import React from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect  } from "react";
import { useNavigate } from "react-router-dom";
import heroImg from "../assets/hero.jpg";
import gallery1 from "../assets/gallery1.jpg";
import gallery2 from "../assets/gallery2.jpg";
import gallery3 from "../assets/gallery3.jpg";
import gallery4 from "../assets/gallery4.jpg";
import gallery5 from "../assets/gallery5.jpg";
import gallery6 from "../assets/gallery6.jpg";
import gallery7 from "../assets/gallery7.jpg";
import gallery8 from "../assets/gallery8.jpg";
import img12_coup6 from "../assets/couple6/img12_coup6.jpg";
import img10_coup3 from "../assets/couple3/img10_coup3.jpg";
import img11 from "../assets/couple1/img11.jpg";
import testim3 from "../assets/testim3.jpg";
import testim5 from "../assets/testim5.jpg";
import testim6 from "../assets/testim6.jpg";
import "./Home.css";

const Home = () => {

  const testimonials = [
    {
      name: "Sushmita & Vamsi",
      text: "We had an absolutely wonderful experience with Navneet and his photography team for our engagement!! The pictures turned out so beautiful everyone loved them, including both our families. Navneet’s patience, professionalism and creative approach truly stood out. He made us feel completely at ease during the couple shoots and guided us so naturally that every moment felt effortless and fun. His dedication to getting the perfect shot and his eye for detail really reflect in the final output. We’re so happy with the results and can recommend Navneet and his team highly enough for anyone looking for a talented and professional photography crew!!!",
      image: img12_coup6
    },
    {
      name: "Sushmita & Srujan",
      text: "You spoke like a friend throughout the entire shoot, Navneet as if you have known me for quite sometime. I think that makes people feel so comfortable during your shoots. I really wish all the very best for all your works. I just wanted to say a huge thank you to you and your team for capturing our wedding so beautifully. I’m usually not very comfortable in front of the camera, but you all made me feel so relaxed and guided me so patiently through every pose. After the haldi shoot, I completely forgot about the camera and just enjoyed the moments — and that really shows in the pictures. You’ve captured everything so gracefully, and I’m genuinely so happy with how the photos turned out. Thank you once again for making our wedding memories so special and unforgettable!",
      image: img11
    },
    {
      name: "Ashwini & Manjunath",
      text: "We are really happy with Navneeth’s photography for our wedding. He captured all the special moments beautifully and made everyone feel comfortable throughout the day. The pictures came out natural, vibrant, and full of emotion. We truly appreciate his professionalism, friendly nature, and attention to detail. Thank you, Navneeth, for making our memories so beautiful!",
      image: img10_coup3 
    },
    {
      name: "Vijaya & Sagar",
      text: "Navaneeth, Thanks a lot for accepting our request despite your busy schedule. First of all, I didn’t know where to take our pre-wedding photos, but you suggested doing it at the temple which turned out to be a great idea. Me and the Vijaya are camera shy persons, but you guided us so well with new ideas, poses and made us feel comfortable. The photos came out fantastic! I really appreciate your creativity, and patience throughout the shoot. Vijaya is very happy with the photos and I shared them with my family&friends on WhatsApp -everyone absolutely loved them.I would gladly recommend your work to anyone looking for high quality photography.",
      image: testim6
    },
    {
      name: "Laksmikanth & Neeharika",
      text: "Navneet is the best! He captured our wedding day perfectly. His photos are amazing, like a movie. He knows exactly what to capture and how to make it special. We're so happy with how everything turned out. He became our family photographer after seeing his output. Highly recommend him to anyone looking for a great photographer",
      image: testim5
    },
    {
      name: "Himabindu",
      text: "I highly recommend Navaneet for his exceptional photography skills, friendly demeanor, and ability to put everyone at ease. His passion for photography shines through in every shot.The photos they took of my family are breathtakingly beautiful.",
      image: testim3 
    },
  ];

  useEffect(() => {
    AOS.init({
      duration: 1000, // animation duration
      once: true,     // animate only once
      disable: 'mobile' // disable on mobile devices
    });
  }, []);

  const navigate = useNavigate();

  return (
    <>
      {/* HERO SECTION */}
      <section className="hero-section d-flex align-items-center text-light">
        <div className="container" data-aos="flip-left">
          <div className="row align-items-center">
            {/* Left Text */}
            <div className="col-lg-6 col-md-12 text-center text-lg-start">
              <p className="text-uppercase text-danger small fw-bold">
                {/* 🌟 Navaneeth Photography 📸 */}
              </p>
              <h1 className="display-4 fw-bold">
                Creative Photography
                Life In Focus, <br /> Moments That Shine, <br /> One Shot At A Time.
              </h1>
              <button
                className="btn btn-danger btn-lg mt-3"
                onClick={() => navigate("/shoot")}>
                Watch Portfolio
              </button>
            </div>

            {/* Right Image */}
            <div className="col-lg-6 col-md-12 text-center mt-4 mt-lg-0">
              <img
                src={heroImg}
                alt="Photographer"
                className="img-fluid rounded shadow-lg hero-img"
                style={{ width: "105%", maxWidth: "400px", height: "auto" }}
              />
            </div>
          </div>
        </div>
      </section>


      {/* FEATURED GALLERY */}
      <section className="py-5 bg-dark text-center text-light moments-section">
        <div className="container">
          <h2 className="fw-bold mb-4 text-uppercase" data-aos="fade-left">
            💞 Moments Captured 🌸
          </h2>
          <p className="text-light opacity-75 mb-5 fs-5" data-aos="fade-right">
            Every frame tells a story from heartfelt wedding moments to magical pre-wedding journeys.
            Each photograph is a blend of light, emotion, and artistry, crafted to preserve your most beautiful memories.
            These handpicked captures reflect the true essence of <strong>AestheticTales by Navaneeth</strong> —
            where every click transforms fleeting moments into timeless tales.
          </p>

          <div className="row g-3 justify-content-center" data-aos="fade-left">
            {[gallery1, gallery2, gallery3, gallery4, gallery5, gallery6, gallery7, gallery8].map(
              (img, index) => (
                <div key={index} className="col-6 col-md-4 col-lg-3">
                  <div className="gallery-image-wrapper">
                    <img
                      src={img}
                      alt={`Gallery ${index + 1}`}
                      className="img-fluid rounded-3 gallery-image"
                    />
                  </div>
                </div>
              )
            )}
          </div>

          <p className="text-light opacity-75 mb-5 fs-5 mt-5" data-aos="fade-right">
            Behind every photograph lies a story waiting to be told stories of love, laughter, and connection.
            With a keen eye for detail and passion for natural storytelling, we capture emotions that words can’t express.
            Here’s a glimpse into the visual narrative of <strong>AestheticTales by Navaneeth,</strong> where art meets emotion through every frame.
          </p>

          <p className="text-light opacity-75 mb-5 fs-5 mt-5" data-aos="fade-left">
            Photography is more than capturing images it’s about freezing emotions in time.
            From candid smiles to breathtaking backdrops, each photograph celebrates life’s most intimate moments.
            Dive into the world of <strong>AestheticTales by Navaneeth,</strong> where every shot echoes beauty, joy, and timeless storytelling.
          </p>
        </div>
      </section>


      {/* TESTIMONIALS SECTION */}
      <section className="py-5 text-center testimonials-section">
        <div className="container">
          <h2 className="fw-bold mb-4 text-uppercase">💬 What Clients Say ✨</h2>
          <div className="row justify-content-center">
            {testimonials.map((t, index) => (
              <div key={index} className="col-md-6 mb-4" data-aos="fade-left">
                <div className="testimonial-card h-100">
                  <div className="testimonial-img-wrapper mb-3">
                    <img src={t.image} alt={t.name} className="testimonial-img" />
                  </div>
                  <p className="fst-italic mb-3">“{t.text}”</p>
                  <h6 className="fw-bold mb-0">— {t.name}</h6>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>


      {/* CTA SECTION */}
      <section className="py-5 text-light" style={{
        background: "linear-gradient(90deg, #000000, #222222)"
      }}>
        <div className="container text-center">
          <h2 className="fw-bold mb-3">Let’s Capture Your Big Day</h2>
          <p className="mb-4 fs-5 text-light opacity-75">
            Beautiful moments deserve to be preserved forever. Let’s make it happen!
          </p>
          <button
            className="btn btn-danger btn-lg rounded-pill"
            onClick={() => navigate("/contact")}>
            Contact Us →
          </button>
        </div>
      </section>
    </>
  );
};

export default Home;
